import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { termsAndconditions } from 'constants/flightsCreditRebooking'
import BodyText from 'components/Luxkit/Typography/BodyText'

const Root = styled.div`
  > * + * {
    margin-top: ${rem(4)};
  }
`

interface Props {
  flightCreditFee: number;
  currency: string;
  className?: string;
}

function TermsAndConditionsList(props: Props) {
  const { className, flightCreditFee, currency } = props

  return <Root className={className}>
    {termsAndconditions.map((content, index) =>
      <BodyText key={index} variant="large">
        {index === 2 && `${index + 1}. Luxury Escapes reduced service fee - $${flightCreditFee} ${currency} per person, per ticket.`}
        {index !== 2 && `${index + 1}. ${content}`}
      </BodyText>,
    )}
  </Root>
}

export default TermsAndConditionsList
